<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
const targets = [
  { url: 'https://api.ipify.org?format=json', parse: d => d.ip, type: 'json' },
  { url: 'https://ipv4.icanhazip.com', parse: t => t.trim(), type: 'text' },
  { url: 'https://ifconfig.co/ip', parse: t => t.trim(), type: 'text' },
  { url: 'https://api.ip.sb/ip', parse: t => t.trim(), type: 'text' },
  { url: 'https://ipapi.co/json/', parse: d => d.ip, type: 'json' },
];

async function getIP() {
  for (const t of targets) {
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 6000); // 单个接口超时 6s
      const resp = await fetch(t.url, { cache: 'no-store', signal: controller.signal });
      clearTimeout(timeout);
      if (!resp.ok) throw new Error('HTTP ' + resp.status);
      const data = t.type === 'json' ? await resp.json() : await resp.text();
      const ip = t.parse(data);
      if (!ip) throw new Error('空返回');
      else {
        return ip
        break;
      }
    } catch (e) {
      // console.debug('接口失败', t.url, e.message);
    }
  }
}

export default {
  created() {
    this.init()
  },
  methods: {
    async init() {
      var IP = await getIP()
      if (IP) {
        var sheb = '电脑'
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          sheb = '手机'
        }
        this.$http('/App/AddVisitLog', { type: this.$isxj ? '讯捷' : '畅邮', SType: sheb, IP}).then(x => {
          var _this = this
          window.setInterval(function () {
            _this.$http('/App/UpdateVisitLog', { id: x }).then(x => {
            })
          }, 10000);
        })
        return
      }
      // alert('获取位置信息失败！')
    }
  }
}
</script>
<style>
* {
  font-family: 微软雅黑 !important;
}

body {
  background: #ffffff;
  color: #333333;
  --color-primary: #1e66d1;
  --color-content1: #333;
  --color-content2: #666;
  --color-tips1: #999;
  font-family: "shuhei";
  text-align: justify;
  /* overflow-x: hidden; */
}

.file {
  display: flex;
}

.falign {
  align-items: center;
}

.containerb {
  max-width: 1200px;
}

.cprimary {
  color: #1e66d1;
}

.bprimary {
  background: #1e66d1;
}

.ctext {
  color: #666666 !important;
}

.ftitle {
  font-size: 20px !important;
}

.fbold {
  font-weight: bold;
}

.ftext {
  font-size: 14px !important;
}

.mtop {
  margin-top: 30px;
}

.mtopb {
  margin-top: 20px;
}

.pointer {
  cursor: pointer;
}

.hprimary:hover {
  color: #1e66d1;
}

.hezuoanlie div {
  width: 18%;
}

img {
  /* object-fit:none; */
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  /* image-rendering: crisp-edges; */
  -ms-interpolation-mode: nearest-neighbor;
}

.swiper-wrapper .object-cover {
  object-fit: none !important;
}

.buttondh {
  transition: transform 0.1s ease;
  /* 过渡定义在默认状态 */
}

.buttondh:hover {
  transform: scale(1.05);
  background: #1e66d1;
  color: #fff !important;
  /* box-shadow:rgb(218 218 218) 0px 5px 10px 0px */
}

.buttondhb:hover {
  transform: translateY(-1px);
  box-shadow:rgb(200, 200, 200) 0px 5px 10px 0px
}

.buttondh:active {
  /* transform: scale(0.95);  */
}

/* 或下移2像素 */
.buttondh:active {
  transform: translateY(2px);
}

.clickbutton {
  transition: transform 0.1s ease;
}

.clickbutton:active {
  transform: translateY(2px);
}

.lifors {
  transition: transform 0.1s ease;
}

.lifors:hover {
  transform: scale(1.02);
}
</style>